<template>
	<el-form ref="form" :model="agreement" :rules="validation_rules" label-position="top" class="note-card">
		<h1>Agreement</h1>
		<div class="agreement-header">
			<p class="agreement-disclaimer">We, the Grantor and Grantee, hereby certify to the best of our knowledge that this request is a true and accurate portrayal of the transfer of land interest under the Charleston County Greenbelt Program.</p>
			<hr>
			<p class="sign-tip">Use cursor or finger (if on touchscreen) to sign</p>
		</div>
		<h2>Grantor - (Eligible Greenbelt Fund Recipient)</h2>
		<div class="signature-container">
			<VueSignaturePad :options="grantor_pad_options" ref="grantor_signature_canvas"/>
		</div>
		<el-row type="flex" :gutter="20">
			<el-col>
				<el-form-item label="Name" prop="grantor.name">
					<el-input v-model="grantor_name"/>
				</el-form-item>
			</el-col>
			<el-col>
				<el-form-item label="Title" prop="grantor.name">
					<el-input v-model="grantor_title"/>
				</el-form-item>
			</el-col>
			<el-col>
				<el-button @click="clearGrantor">Clear Signature</el-button>
			</el-col>
		</el-row>
		<hr>
		<h2>Grantee - (Agency Requesting Land Interest)</h2>
		<div class="signature-container">
			<VueSignaturePad :options="grantee_pad_options" ref="grantee_signature_canvas"/>
		</div>
		<el-row type="flex" :gutter="20">
			<el-col>
				<el-form-item label="Name" prop="grantee.name">
					<el-input v-model="grantee_name"/>
				</el-form-item>
			</el-col>
			<el-col>
				<el-form-item label="Title" prop="grantee.title">
					<el-input v-model="grantee_title"/>
				</el-form-item>
			</el-col>
			<el-col>
				<el-button @click="clearGrantee">Clear Signature</el-button>
			</el-col>
		</el-row>
	</el-form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { mapSimpleValidation } from '@/js/utilities/validation-mapper.js';
export default{
	computed: {
		...mapState('application', ['agreement']),
		...mapFields('application/agreement', {
			grantor_signature: 'grantor.signature',
			grantor_signature_date: 'grantor.date',
			grantor_signature_points: 'grantor.signature_points',
			grantor_name: 'grantor.name',
			grantor_title: 'grantor.title',

			grantee_signature: 'grantee.signature',
			grantee_signature_date: 'grantee.date',
			grantee_signature_points: 'grantee.signature_points',
			grantee_name: 'grantee.name',
			grantee_title: 'grantee.title',

		})
	},
	mounted(){
		this.$refs.grantor_signature_canvas.fromData(this.grantor_signature_points.slice(0));
		this.$refs.grantee_signature_canvas.fromData(this.grantee_signature_points.slice(0));
	},
	watch: {
		grantor_signature_points(new_signature, old_signature){
			if(old_signature !== new_signature){
				// this.$refs.grantor_signature_canvas.clearSignature();
				this.$refs.grantor_signature_canvas.fromData(new_signature.slice(0));
			}
		},
		grantee_signature_points(new_signature, old_signature){
			if(old_signature !== new_signature){
				// this.$refs.grantee_signature_canvas.clearSignature();
				this.$refs.grantee_signature_canvas.fromData(new_signature.slice(0));
			}
		}
	},
	methods: {
		...mapActions('application', ['setSectionStatus', 'submitApplication']),
		updateGrantorSignature(){
			this.grantor_signature_points = this.$refs.grantor_signature_canvas.toData();
			this.grantor_signature_date = new Date();
		},
		updateGranteeSignature(){
			this.grantee_signature_points = this.$refs.grantee_signature_canvas.toData();
			this.grantee_signature_date = new Date();
		},
		clearGrantor(){
			this.grantor_signature_points = [];
			this.grantor_signature_date = null;
			this.$refs.grantor_signature_canvas.clearSignature();
		},
		clearGrantee(){
			this.grantee_signature_points = [];
			this.grantee_signature_date = null;
			this.$refs.grantee_signature_canvas.clearSignature();
		},
		validateForm(){
			// Custom validation overriding mixin
			let input_fields_valid = null;
			this.$refs.form.validate( valid => {
				input_fields_valid = valid;
			});

			const { grantor_signature_canvas, grantee_signature_canvas } = this.$refs
			if(grantor_signature_canvas.isEmpty() || grantee_signature_canvas.isEmpty()){
				this.$notify.error({
					title: 'Need Signature',
					message: 'Please check your signatures'
				});
			}

			const success_conditions = (input_fields_valid && !grantor_signature_canvas.isEmpty() && !grantee_signature_canvas.isEmpty());
			this.setSectionStatus(success_conditions)
			return success_conditions;
		},
		saveAgreement(){
			this.grantor_signature = (this.$refs.grantor_signature_canvas.saveSignature('image/svg+xml')).data;
			this.grantee_signature = (this.$refs.grantee_signature_canvas.saveSignature('image/svg+xml')).data;
			const warning_message = 'Keep in mind that you have until two weeks before the Greenbelt Advisory Board (GAB) meeting to submit this application. Once it is submitted, you may no longer return to make any changes. If you are absolutely sure about completion, please proceed.';
			this.$confirm(warning_message, 'Are you sure?', {
				confirmButtonText: 'Submit Application',
				cancelButtonText: 'Cancel',
				type: 'warning'
			}).then(() => {
				this.submitApplication();
			}).catch(() => {
				// Canceled... do nothing
			})
		},
	},
	data(){
		return {
			validation_rules: {
				...mapSimpleValidation([
					'grantor.name', 'grantor.title', 'grantee.name', 'grantee.title'
				]),
			},
			grantor_pad_options: {
				backgroundColor: 'rgb(239,237,248)',
				onEnd: this.updateGrantorSignature
			},
			grantee_pad_options: {
				backgroundColor: 'rgb(239,237,248)',
				onEnd: this.updateGranteeSignature
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.agreement-header{
	max-width:600px;
	margin:0 auto;
	text-align: center;

	.agreement-disclaimer{
		text-align: justify;
	}
}
.signature-container{
	background:rgb(239,237,248);
	position:relative;
	border:1px solid lightgray;
}
</style>

<style scoped>
.note-card >>> canvas{
	/* border:1px dotted gray; */
	/* width: auto !important;
	height: auto !important; */

}
.note-card >>> .el-row{
	margin-top:15px;
}
.note-card >>> .el-button{
	margin-top:27px;
}
</style>
